import {reactive, ref, computed} from "vue"
import store from '../store';

export const languageTxtJson = reactive({
  'en': {},
  'ru': {}
})

if (languageTxtJson[navigator.language]) {
  store.commit('setLanguage', navigator.language)
}

const modules = require.context('../assets/language', false, /\.json$/);
const getJson = async () => {
  const modulePath = `./${store.state.language}.json`;
  const module = modules(modulePath);
  if (module) {
    return module;
  } else {
    return ''
  }
};

export const getText = (
  key
) => {
  return String(languageTxtJson[store.state.language] && languageTxtJson[store.state.language][key] ? languageTxtJson[store.state.language][key] : key)
}


export const getTextJson = () => {
  return new Promise(async resolve => {
    if (languageTxtJson[store.state.language]) {
      resolve(true)
    }
    const json = await getJson()
    if (json) {
      languageTxtJson[store.state.language] = json
      resolve(true)
    } else {
      resolve(false)
    }
  })
}

export default languageTxtJson



// WEBPACK FOOTER //
// ./src/utils/text.js